import { useState } from 'react';
import styled from 'styled-components';
import { BUTTON_SIZES, GhostButton } from 'ui/button';
import { Controlbar, ControlGroup } from 'ui/Controlbar';
import { FilterMenuTriggerButton } from 'ui/indexPages/filters/FilterMenuTriggerButton';
import { InputSearch } from 'ui/inputs';
import { ALIGNMENT, Menu } from 'ui/menu';
import { IndexTabsList, IndexTabTrigger, TabsGroup } from 'ui/tabsGroup';
import { pxToRem } from 'utils/convert';
import { useDebouncedEffect } from 'utils/hooks/useDebouncedEffect';
import { GOALS_TAB_FILTERS, SEARCH_TEXT_INPUT_DEBOUNCE_TIMEOUT_MS } from '../constants';
import { useGoalsContext } from '../contexts/GoalsContext';
import { useFilterOptions } from '../hooks/useFilterOptions';
import { GoalStatus } from '../types';

export const WideInputText = styled(InputSearch)`
  width: ${pxToRem(304)};
`;

export const GoalsPageControlbar = () => {
  const {
    searchQuery,
    setSearchQuery,
    setStates,
    states,
    status,
    setStatus,
    clearFilters,
    selectedFiltersCount = 0,
  } = useGoalsContext();

  const [search, setSearch] = useState(searchQuery);

  /**
   * Debouncing the search input. So, that we don't keep querying
   * the backend for every input change.
   */
  useDebouncedEffect(() => setSearchQuery(search), [search], {
    skipEffectOnMount: true,
    debounceTimeout: SEARCH_TEXT_INPUT_DEBOUNCE_TIMEOUT_MS,
  });

  const filterOptions = useFilterOptions();

  return (
    <Controlbar variant="ghost" aria-label="Goals page controls">
      <ControlGroup aria-label="Goals page tabs">
        <TabsGroup
          value={status}
          defaultValue={GoalStatus.ALL}
          onValueChange={(value) => {
            setStatus(value as GoalStatus);
          }}
        >
          <IndexTabsList>
            {GOALS_TAB_FILTERS.map(({ id, label }) => (
              <IndexTabTrigger key={id} value={id}>
                {label}
              </IndexTabTrigger>
            ))}
          </IndexTabsList>
        </TabsGroup>
      </ControlGroup>

      <ControlGroup aria-label="Goals page filters">
        {selectedFiltersCount > 0 && (
          <GhostButton onClick={clearFilters} tabIndex={0} size={BUTTON_SIZES.LARGE}>
            Clear
          </GhostButton>
        )}
        <Menu
          options={filterOptions}
          defaultSelectedOptionIds={states}
          verticalAlignment={ALIGNMENT.DOWN}
          horizontalAlignment={ALIGNMENT.RIGHT}
          handleSelectionChange={(id: any) => {
            setStates([id]); // TODO: support multiple states
          }}
        >
          <FilterMenuTriggerButton selectedFilterCount={selectedFiltersCount} />
        </Menu>

        <WideInputText
          value={search}
          onChange={setSearch}
          id="goals-search-input"
          placeholder="Search goals"
          data-test="goals-search-input"
        />
      </ControlGroup>
    </Controlbar>
  );
};
